import React , {useState, useEffect} from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Accordion, AccordionSummary, AccordionDetails, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { getAuth } from "firebase/auth";
import callApi from "../common/APIClient";

const PipelineTable = () => {

  const [pipelines, setPipelines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expanded, setExpanded] = useState(null);

  // Handle file upload to REST API
  const getPipelines = async () => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) {
        console.error("User not authenticated");
        return;
      }
      const token = await user.getIdToken(); // 🔐 this is your Bearer token

      const response = await callApi({
        url: "/pipelines/",
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      
      setPipelines(response.pipelines);
      console.log('Server Response:', response);
    } catch (error) {
      console.error('Processing Pipelines error:', error);
      setError(error);
      setLoading(false);
    } finally {
      //setProcessing(false);
    }
  };

  useEffect(() => {
    getPipelines();
  }, []);

  const handleExpand = (pipelineId) => {
    setExpanded(expanded === pipelineId ? null : pipelineId);
  };

  const openPipelineFlow = (pipeline) => {
    // Convert pipeline data to URL-encoded JSON
    const encodedData = encodeURIComponent(JSON.stringify(pipeline.stages));
    // Get the current URL origin (so it works in production & local)
    const url = `${window.location.origin}/pipeline?data=${encodedData}`;
    console.log('url');
    console.log(url);
    // Open the new popup window at the correct route
    window.open(url, "_blank", "width=800,height=600");
  };

  //if (loading) return <Typography>Loading pipelines...</Typography>;
  if (error) return <Typography color="error">Error loading pipelines: {error.message}</Typography>;

  return (
    <TableContainer component={Paper} style={{ backgroundColor: "#1a1a2e", color: "#00f5d4" }}>
      <Typography variant="h5" align="center" sx={{ p: 2 }}>Pipeline List</Typography>
      <Table>
        <TableHead>
          <TableRow style={{ backgroundColor: "#00f5d4" }}>
            <TableCell style={{ color: "#000" }}>Pipeline ID</TableCell>
            <TableCell style={{ color: "#000" }}>Created At</TableCell>
            <TableCell style={{ color: "#000" }}>Details</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pipelines.map((pipeline) => (
            <React.Fragment key={pipeline.pipeline_id}>
              {/* Main Row */}
              <TableRow 
                onClick={() => handleExpand(pipeline.pipeline_id)} 
                style={{ 
                  backgroundColor: "#0d1b2a", 
                  color: "#00f5d4", 
                  cursor: "pointer" 
                }}
              >
                <TableCell>{pipeline.pipeline_id}</TableCell>
                <TableCell>{new Date(pipeline.created_at).toLocaleString()}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleExpand(pipeline.pipeline_id)}>
                    <ExpandMoreIcon />
                  </IconButton>
                  <IconButton onClick={() => openPipelineFlow(pipeline)}>
                    <OpenInNewIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
              {/* Expanded Detail View */}
              {expanded === pipeline.pipeline_id && (
                <TableRow>
                    <TableCell colSpan={3}>
                        <Accordion expanded>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography variant="h6">Pipeline Details</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography variant="subtitle1"><b>Stages</b></Typography>
                                {Object.entries(pipeline.stages).map(([stage, details]) => (
                                    <div key={stage} style={{ paddingLeft: "20px" }}>
                                        <Typography variant="subtitle2">{stage.toUpperCase()}</Typography>
                                        <pre style={{ backgroundColor: "#0d1b2a", color: "#00f5d4", padding: "10px", borderRadius: "5px" }}>
                                            {JSON.stringify(details, null, 2)}
                                        </pre>
                                    </div>
                                ))}

                                <Typography variant="subtitle1"><b>Variables</b></Typography>
                                <pre style={{ backgroundColor: "#0d1b2a", color: "#00f5d4", padding: "10px", borderRadius: "5px" }}>
                                    {JSON.stringify(pipeline.variables, null, 2)}
                                </pre>
                            </AccordionDetails>
                        </Accordion>
                    </TableCell>
                </TableRow>
              )}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>    
  );
};

export default PipelineTable;
